<template>
  <div class="auth-form signin-form">
    <p class="auth-form__title">Sign in to your account</p>
    <form @submit.prevent="pressed">
      <div class="input">
        <label for="email">Mail</label>
        <input type="email" id="email" v-model="email" />
      </div>
      <div class="input">
        <label for="password">Password</label>
        <input type="password" id="password" v-model="password" />
      </div>
      <h5 id="showbtn">
        <input
          type="checkbox"
          id="showMe"
          class="input-field"
          @click="showPassword"
        /> Show Password
      </h5>
      <div class="submit1">
        <button
          type="submit"
          class="emailbtn"
          :disabled="!canSubmit"
          :title="!canSubmit ? 'Complete all fields to continue' : 'Sign in with email'"
        >
          Sign in with email
        </button>
      </div>
    </form>
    <div class="error" v-if="error">{{ error.message }}</div>
    <br />
    <h5 class="divider">Or</h5>
    <div class="submit" style="margin-top: 15px;">
      <button @click="signInWithgoogle" class="googlebtn">
        Sign in with Google
      </button>
    </div>
    <span class="signfoot">Need an account? Click here to <router-link to="/signup">register</router-link></span>
    <br />
    <span class="signfoot">Forgot your password? <a href="#" @click.prevent="handleReset">Reset it</a></span>
  </div>
</template>

<script>
import swal from "sweetalert";
import { auth, signInWithGoogle, resetPassword } from "../firebase/firebase.utils";

export default {
  data() {
    return {
      email: null,
      password: "",
      error: "",
    };
  },
  methods: {
    async pressed() {
      try {
        const val = await auth
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() =>
              swal({
                title: `Signed in as ${this.email}!`,
                text: "You've successfully signed in!",
                icon: "success",
                button: "Continue",
              })
            );
          this.$router.replace({ name: "Home" });
      } catch (error) {
        swal({
          title: "Wrong Email or Password!",
          text:
            "Please, input the correct login details or check your internet connection and try again!",
          button: "OK",
          dangerMode: true,
        });
      }
    },

    async signInWithgoogle() {
      try {
        signInWithGoogle().then(() =>
          swal({
            title: `Welcome!`,
            text: "You've successfully signed in!",
            icon: "success",
            button: "Continue",
          })
        );
        this.$router.replace({ name: "Home" });
      } catch (error) {
        swal({
          title: "Login Failed!",
          text:
            "Please, input the correct login details or check your internet connection and try again!",
          button: "OK",
          dangerMode: true,
        });
      }
    },
    async handleReset() {
      try {
        const promptEmail = await swal({
          text: "Enter the email for your account:",
          content: "input",
          button: true,
        });
        const emailToUse = (this.email && this.email.trim()) || (promptEmail && promptEmail.trim());
        if (!emailToUse) return;
        const res = await resetPassword(emailToUse);
        if (res.ok) {
          swal({
            title: "Reset email sent",
            text: `Check ${emailToUse} for a password reset link.`,
            icon: "success",
            button: "OK",
          });
        } else {
          swal({
            title: "Reset failed",
            text: res.error && res.error.message ? res.error.message : "Unable to send reset email.",
            icon: "error",
            button: "OK",
          });
        }
      } catch (error) {
        swal({ title: "Reset failed", text: error.message || error, icon: "error", button: "OK" });
      }
    },
    showPassword() {
      var Pass = document.getElementById("password");
      var confirmPass = document.getElementById("confirmPassword");
      var showPass = document.getElementById("showMe");
      if (showPass.checked) {
        Pass.setAttribute("type", "text");
      } else {
        Pass.setAttribute("type", "password");
      }
    },
  },
  computed: {
    canSubmit() {
      return this.email && this.password;
    },
  },
};
</script>

<style scoped>
.signin-form .submit1 button,
.signin-form .googlebtn {
  margin-left: 0;
}

.emailbtn[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
